export const paymentPlanLabel = {
  Yes: 'Yes',
  No: 'No',
}
